import type { BalanceStatus } from '@features/invoices/api/types/invoice.types';

import type { OutstandingAmountDisplayType } from './OutstandingAmountCell.types';
export const OUTSTANDING_AMOUNT_DISPLAY_TYPE = {
  AMOUNT: 'amount',
  PAID: 'paid',
  FULL_CREDIT: 'full-credit',
} as const;
export function getOutstandingAmountDisplay(
  balanceStatus?: BalanceStatus
): OutstandingAmountDisplayType {
  if (balanceStatus === 'Paid') return OUTSTANDING_AMOUNT_DISPLAY_TYPE.PAID;
  if (balanceStatus === 'FullCredit')
    return OUTSTANDING_AMOUNT_DISPLAY_TYPE.FULL_CREDIT;
  return OUTSTANDING_AMOUNT_DISPLAY_TYPE.AMOUNT;
}

export function shouldAmountBePastDueColor(
  isPastDue: boolean,
  amount: number
): boolean {
  return isPastDue && amount > 0;
}
